import * as React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import { GetString } from '../../components/StringResourceManager';
// Constants
import { APP_TITLE } from '../../utils/constants';
import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import AccessControlContainer from '../../components/AccessControl/AccessControlContainer';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { Dispatch } from 'redux';
import { useEffect } from 'react';
import { getDivisionList } from '../../store/Assets/AssetsActions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
  }),
);

export default function AccessControlMenu() {
  const classes = useStyles();

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getDivisionList(dispatch);
    }
    return () => {};
  }, [isLogin]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('ACCESS_CONTROL')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header open={true} pageDisplayed={GetString('ACCESS_CONTROL')} />
      <Paper className={classes.paperGrid}>
        <AccessControlContainer />
      </Paper>
    </>
  );
}
